if (!customElements.get('planted-exclusive-accordion-list')) {
  // close all other "details" when one opens
  class PlantedExclusiveAccordionList extends HTMLElement {
    connectedCallback() {
      const allDetails = this.querySelectorAll('details')
      const imageEl = this.querySelector('[data-image]')
      allDetails.forEach((details) => {
        details.addEventListener('toggle', function (e) {
          if (details.open) {
            allDetails.forEach((details) => {
              if (details != e.target && details.open) {
                details.open = false
              }
            })
            const imageUrl =
              this.querySelector('[data-item-image]').getAttribute('src')
            imageEl.style.backgroundImage = `url("${imageUrl}")`
          }
        })
      })
    }
  }
  customElements.define(
    'planted-exclusive-accordion-list',
    PlantedExclusiveAccordionList
  )
}
